import moment, { MomentInput } from "moment";
import { SurveyFrequency } from "typings/app/types";

export const getWeek = (date: MomentInput) => {
  const d = moment(date);
  const dayOfWeek = d.day();
  const week = d.week();
  return `CW ${dayOfWeek > 4 ? week : week-1} ${d.year()}`;
};

export const getMonth = (date: MomentInput) => {
  const d = moment(date);
  const dayOfMonth = d.date();
  const month = dayOfMonth > 15 ? d.month() + 1 : d.month();
  return moment(date).month(month).format("MMM YY");
};

export const getIterationDate = (date: MomentInput, recurrence: string) => {
  if (recurrence === SurveyFrequency.monthly) return getMonth(date);
  else if (
    recurrence === SurveyFrequency.weekly ||
    recurrence === SurveyFrequency["bi-weekly"]
  )
    return getWeek(date);
};
